<template>
    <div>
        <h1 class="title">Contacto</h1>

        <div class="columns">
            <div class="column">
                <article class="media">
                    <figure class="media-left">
                    <span class="icon">
                        <i class="fab fa-whatsapp fa-3x"></i>
                    </span>
                    </figure>
                    <div class="media-content">
                        <div class="content">
                            <p>+54 911 6908-5320</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column">
                <article class="media">
                    <figure class="media-left">
                    <span class="icon">
                        <i class="fal fa-phone fa-3x"></i>
                    </span>
                    </figure>
                    <div class="media-content">
                        <div class="content">
                            <p>0-800-88-TALLO</p>
                        </div>
                    </div>
                </article>
            </div>

            <div class="column">
                <article class="media">
                    <figure class="media-left">
                    <span class="icon">
                        <i class="fal fa-envelope fa-3x"></i>
                    </span>
                    </figure>
                    <div class="media-content">
                        <div class="content">
                            <p>huerta@talloverde.com</p>
                        </div>
                    </div>
                </article>
            </div>
        </div>

        <h1 class="title">Envianos tu consulta</h1>

        <div v-if="!messageSent">
            <span class="subtitle">Si queres enviarnos un mensaje, completá el siguiente formulario y en breve nos pondremos en contacto con vos.</span>

            <div class="form">
                <b-field grouped>
                    <b-field expanded label="Nombre" :type="errors.has('name') ? 'is-danger' : ''" :message="errors.first('name')">
                        <b-input name="name" v-model="message.name" v-validate="'required'"></b-input>
                    </b-field>

                    <b-field expanded label="Teléfono" :type="errors.has('telephoneNumber') ? 'is-danger' : ''" :message="errors.first('telephoneNumber')">
                        <b-input name="phone" v-model="message.phone" v-validate="'required'"></b-input>
                    </b-field>

                    <b-field expanded label="Correo Electrónico" :type="errors.has('email') ? 'is-danger' : ''" :message="errors.first('email')">
                        <b-input name="email" v-model="message.email" v-validate="'required'"></b-input>
                    </b-field>
                </b-field>

                <b-field label="Mensaje" :type="errors.has('message') ? 'is-danger' : ''" :message="errors.first('message')">
                    <b-input type="textarea" name="message" v-model="message.message" v-validate="'required'"></b-input>
                </b-field>

                <b-field grouped position="is-right">
                    <button class="button is-primary" @click="onSubmit">Enviar</button>
                </b-field>
            </div>
        </div>

        <div class="confirmation" v-else>
            <div class="has-text-centered">
                <span class="icon is-large"><i class="fal fa-envelope big-icon"></i></span>
                <h1 class="subtitle">Tu mensaje ha sido enviado. Nos pondremos en contacto contigo a la brevedad.</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                messageSent: false,
                message: {
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                }
            }
        },

        components: {},

        mounted() {
        },

        methods: {
            async onSubmit() {
                let message = this.message.message + '\n';
                message += '\nEmail: ' + this.message.email + '\n';
                message += '\nTeléfono: ' + this.message.phone + '\n';
                
                let title = 'Contacto Web ' + this.message.name;

                try {
                    let result = await this.$api.post('/api/claims', {
                        type: 'claim.contact',
                        title: title,
                        comment: message
                    });

                    this.messageSent = true;
                    window.scrollTo(0, 0);
                }
                catch (error) {
                    if(error.code === 'error.request.invalid') {
                        Object.keys(error.errors).forEach((key) => {
                            let value = error.errors[key];
                            this.errors.add({field: key, msg: value});
                        });
                    }
                }
                finally {

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .media-left {
        .icon {
            color: $primary;
            width: 5em;
            height: 5em;

            svg {
                width: 3em;
                height: 3em;
            }
        }
    }

    .form {
        margin-top: 40px;
    }

    .confirmation {
        margin-top: 40px;

        .big-icon {
            color: $primary;
            font-size: 8em;
            margin-top: 50px;
            margin-bottom: 50px;
        }

        .subtitle {
            margin-top: 40px;
        }
    }

    .media-content {
        margin-top: auto;
        margin-bottom: auto;

        p {
            font-size: 1.1em;
        }
    }
</style>